import { useState } from 'react';
import Card from '../../components/Card';
import AreaChart from '../../components/AreaChart';
import { config } from '../../config/config';
import { ValueOf } from '../../config/constants';
// import useHistoricalProtocolFees from '../../hooks/analytics/useHistoricalProtocolFees';
import useMockHistoricalProtocolFees from '../../hooks/analytics/useMockHistoricalProtocolFees';

const TotalProtocolFees = () => {
    const [timeframeOption, setTimeframeOption] =
        useState<ValueOf<typeof config.areaChartTimeframes>>('1d');
    const [activePayload, setActivePayload] = useState<number | undefined>();

    // const { historicalProtocolFee, defaultData, isLoading } =
    //     useHistoricalProtocolFees(timeframeOption);
    const { historicalProtocolFee, defaultData, isLoading } =
        useMockHistoricalProtocolFees(timeframeOption);

    const handlePayloadChange = (newPayload: number | undefined) => {
        if (newPayload !== activePayload) {
            setActivePayload(newPayload);
        }
    };

    const handleTimeframeChange = (
        newTimeframe: ValueOf<typeof config.areaChartTimeframes>
    ) => {
        setTimeframeOption(newTimeframe);
    };

    return (
        <Card className='large-card'>
            <AreaChart
                isLoading={isLoading}
                data={historicalProtocolFee ?? defaultData}
                withKpi
                activePayload={historicalProtocolFee ? activePayload : undefined}
                onActivePayloadChange={handlePayloadChange}
                label='Total Protocol Fees'
                activePayloadLabel='Total Protocol Fees'
                withTimeFrames
                timeframes={config.areaChartTimeframes}
                onTimeframeChange={(timeframe) => handleTimeframeChange(timeframe)}
            />
        </Card>
    );
};
export default TotalProtocolFees;
